<template>
  <div>
    <!-- <div v-if="userDetails.coverPhoto != ''">
      <img
        :src="$imageURL + '/' + userDetails.coverPhoto"
        alt="profilecover"
        class="w-full profile-cover-h object-cover"
      />

      <div class="absolute top-4 right-4 cursor-pointer">
      <feather-icon icon="CameraIcon" />
    </div>
    </div> -->
    <div>
      <img
        src="@/views/e-learning/img/profile/cover.jpg"
        alt="profilecover"
        class="w-full profile-cover-h object-cover"
      />

      <!-- <div class="absolute top-4 right-4 cursor-pointer">
      <feather-icon icon="CameraIcon" />
    </div> -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    userDetails: Object,
  },
  computed: {
    ...mapState("auth", ["userData"]),
  },
};
</script>
